
import { Injectable, OnInit, Pipe } from '@angular/core';
import axios, { AxiosResponse } from 'axios';
import { environment } from 'environments/environment';
import { PreloaderService } from './preloader.service';
@Injectable()
export class EngaugeAIService {

    constructor(
        private _preloaderService: PreloaderService
    ) {
    }

    getAIChatHistory(referenceId){
      const url = `${environment.engaugeAIURL}chat-history/referenceId/${referenceId}`;
      const that = this;
      that._preloaderService.showPreloader();
      return new Promise((resolve, reject) => {
        axios.get(url)
              .then(function (res) {
                  that._preloaderService.hidePreloader();
                  resolve(res.data);
              }).catch(function (error) {
                  that._preloaderService.hidePreloader();
                  if (error && error.response && error.response.status === 422) {
                    resolve({ code: error.response.status, data: error.response.data })
                  }else{
                    resolve({})
                  }
              })
      })
  }

  syncCandidateWithAI(referenceId){
      const url = `${environment.engaugeAIURL}recipient/referenceId/${referenceId}/outcome`;
      const that = this;
      that._preloaderService.showPreloader();
      return new Promise((resolve, reject) => {
        axios.get(url)
              .then(function (res) {
                  that._preloaderService.hidePreloader();
                  resolve(res.data);
              }).catch(function (error) {
                  that._preloaderService.hidePreloader();
                  if (error && error.response && error.response.status === 422) {
                    resolve({ code: error.response.status, data: error.response.data })
                  }else{
                    resolve({})
                  }
              })
      })
  }

  syncJobOrderWithAI(status,jobSfdcId){
      const url = `${environment.engaugeAIURL}jobOrder/agentType/${status}/jobId/${jobSfdcId}/status`;
      const that = this;
      that._preloaderService.showPreloader();
      return new Promise((resolve, reject) => {
        axios.get(url)
              .then(function (res) {
                  that._preloaderService.hidePreloader();
                  resolve(res.data);
              }).catch(function (error) {
                  that._preloaderService.hidePreloader();
                  if (error && error.response && error.response.status === 422) {
                    resolve({ code: error.response.status, data: error.response.data })
                  }else{
                    resolve({})
                  }
              })
      })
  }

  async postData(url: string, data: any, config?: any): Promise<AxiosResponse<any>> {
    try {
      const fullUrl = `${environment.engaugeAIURL}${url}`;
      const response = await axios.post(fullUrl, data, config);
      return response;
    } catch (error) {
      throw error;
    }
  }


}
